import { ArrowUpRight } from 'lucide-react';

/** The workspace-qualified record URL the API and GTM Accounts use for Attio companies. */
export function attioCompanyUrl(recordId: string): string {
  return `https://app.attio.com/sequesto/companies/record/${recordId}/overview`;
}

/** Row-end link out to a company's Attio record. Clicks don't toggle the row. */
export function AttioCompanyLink({ recordId, name }: { recordId: string; name?: string | null }) {
  return (
    <a
      href={attioCompanyUrl(recordId)}
      target="_blank"
      rel="noreferrer"
      onClick={(e) => e.stopPropagation()}
      title="Open in Attio"
      aria-label={`Open ${name ?? 'company'} in Attio`}
      className="inline-flex h-7 w-7 items-center justify-center rounded text-text-muted hover:bg-surface-secondary hover:text-text-primary focus:outline-none focus-visible:ring-1 focus-visible:ring-text-primary"
    >
      <ArrowUpRight className="h-4 w-4" aria-hidden />
    </a>
  );
}

/** Loose company-name key so Odoo and Attio spellings ("Kapsch AG" vs "Kapsch") can meet. */
export function companyKey(name: string | null | undefined): string {
  return (name ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\b(sa|nv|bv|gmbh|ag|ltd|limited|plc|inc|llc|srl|sas|s\.a\.|n\.v\.|b\.v\.|group|holding)\b/g, '')
    .replace(/[^a-z0-9]+/g, '');
}
